/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

/* tslint:disable:max-classes-per-file */
// tslint:disable:max-classes-per-file 
import { Action } from '@ngrx/store';

export const SHOW_TEAM_SELECTION_MODAL = '[Team Selection Modal] Show Team Selection Modal';
export const HIDE_TEAM_SELECTION_MODAL = '[Team Selection Modal] Hide Team Selection Modal';

export class ShowTeamSelectionModal implements Action {
  readonly type = SHOW_TEAM_SELECTION_MODAL;
  constructor(public payload: any) {}
}

export class HideTeamSelectionModal implements Action {
  readonly type = HIDE_TEAM_SELECTION_MODAL;
  constructor(public payload: any) {}
}

// action types
export type TeamSelectionAction = ShowTeamSelectionModal | HideTeamSelectionModal;
